
import DefaultController from './../../controller';
import {createObjectFromDefault} from './../../functions';

class SvgArc extends DefaultController{

    constructor(parent, blueprint={}){

        super(parent, blueprint);

        this.type = 'path';

    }

    polarToCartesian(centerX, centerY, radius, angleInDegrees) {
        let angleInRadians = (angleInDegrees-90) * Math.PI / 180.0;

        return {
            x: centerX + (radius * Math.cos(angleInRadians)),
            y: centerY + (radius * Math.sin(angleInRadians))
        };
    }

    describeArc(x, y, radius, startAngle, endAngle, s='M'){

        let start = this.polarToCartesian(x, y, radius, endAngle);
        let end = this.polarToCartesian(x, y, radius, startAngle);

        let largeArcFlag = Math.abs(endAngle - startAngle) <= 180 ? '0' : '1';
        let sweepFlag = (s=='M')? 0: 1;

        let d = [
            s, start.x, start.y, 
            'A', radius, radius, 0, largeArcFlag, sweepFlag, end.x, end.y
        ].join(' ');

        return d;       
    }

    getPath(){
        let d = this.describeArc(this.data.x, this.data.y, this.data.radius, this.data.a1, this.data.a2);
        if(this.data.innerRadius == 0){
            d += ' Z'
        }else{
            d += this.describeArc(this.data.x, this.data.y, this.data.innerRadius, this.data.a2, this.data.a1, 'L');
            let p = this.polarToCartesian(this.data.x, this.data.y, this.data.radius, this.data.a2);
            d += 'L ' + p.x + ' ' + p.y + ' Z'; 
        }
        return d;
    }
    
    
}

// you can extend a blue print for a parent component by importing it
// and using let Blueprint = Object.assign(parentBlueprint, {my: 'settings'});

let Blueprint = {
    type: SvgArc,
    properties: {
        data: {
            x: 0,
            y: 0,
            radius: 10,
            innerRadius: 0,
            a1: 0,
            a2: 360
        }, 
        attributes: {
            d: (ctrl) => ( ctrl.getPath() )
        }
    },
    events: {   },
    children: []
}

export default Blueprint;
export {SvgArc, Blueprint};
